import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import '../Invoice/style.module.css';
import { useRef } from 'react';
import QRCode from "qrcode";
import { BASEAPIURL, BASEURL, showdatetimein } from '../../config';

const StudentCertificate = () => {
    const printRef = useRef();
    const [dataUrl, setDataUrl] = useState(null);
    const { cartID } = useParams();
    async function generate(certificateID) {
        // setLoading(true);
        try {
        const url = await QRCode.toDataURL(`${BASEURL}certificate/${certificateID}`, { margin: 2, scale: 8 });
        setDataUrl(url);
        } catch (err) {
        console.error(err);
        } finally {
        // setLoading(false);
        }
    }

    const handleDownloadPdf = async () => {
        setDownloading(true);
        const element = printRef.current;

        const canvas = await html2canvas(element, { 
            scale: 2,
            useCORS: true,
        });
        const data = canvas.toDataURL("image/png");

        // Landscape PDF
        const pdf = new jsPDF("l", "mm", "a4");
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();

        // Get image dimensions
        const imgWidth = canvas.width;
        const imgHeight = canvas.height;

        // Scale image proportionally to fit into PDF
        const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
        const newWidth = imgWidth * ratio;
        const newHeight = imgHeight * ratio;

        // Center the content on the page
        const x = (pdfWidth - newWidth) / 2;
        const y = (pdfHeight - newHeight) / 2;

        pdf.addImage(data, "PNG", x, y, newWidth, newHeight);

        pdf.save(`Acumen-Glow-Certificate-${cartID}.pdf`);
        setDownloading(false);
    };


    const [downloading, setDownloading] = useState(false);
    const [certificate, setCertificate] = useState({});
    const [course, setCourse] = useState({});
    const [student, setStudent] = useState({});
    const FetchInvoice = async (objects = {}) => {
        try {
            const res = await fetch(`${BASEAPIURL}/student/DataCertificate`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Basic ${localStorage.getItem('loggedToken')}`,
                },
                body: JSON.stringify(objects),
            });
            const resJson = await res.json();
            if (res.status === 200 && resJson) {
                if (resJson.course) {
                    setCourse(resJson.course);
                }
                if (resJson.student) {
                    setStudent(resJson.student);
                }
                if (resJson.certificate) {
                    setCertificate(resJson.certificate);
                    generate(resJson.certificate._id)
                }
            } else {
                setCertificate({});
            }
        } catch (err) {
            console.log(err);
            setCertificate({});
        }
    };

    useEffect(() => {
        FetchInvoice({ cartID });
    }, [cartID]);

    if (!certificate._id) {
        return (
            <>
                <div className="pt-3 pb-3 mt-5 text-center">
                    <h3 ref={printRef} className=" mt-5 container text-center text-danger">
                        Something went wrong, Please again later.
                    </h3>
                    <a href="/" className='btn btn-lg mt-3 btn-success'>Back to Home</a>
                </div>
            </>
        )
    }

    return (
        <>
        <div className="container pt-3 pb-3" style={{ minWidth: "1024px" }}>
            <div className='text-left'>
                {downloading ? (
                    <button className="mb-4 btn btn-danger px-4 py-2 rounded-lg">
                        Downloading...
                    </button>
                ) : (
                    <button
                        onClick={handleDownloadPdf}
                        className="mb-4 btn btn-info px-4 py-2 rounded-lg"
                    >
                        Download Certificate
                    </button>
                )}   
            </div>        
            <div ref={printRef} className="container pt-3 pb-3">


            <div className="certificate-border">
                {/* Header with logo and invoice info */}
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: 'center' }}>
                        <img
                            src="/logo.png"
                            alt="Logo"
                            style={{ height: "40px" }}
                        />
                        <div style={{ textAlign: "center" }}>
                            <h3 style={{ color: "#cc0000" }}>
                                ACUMEN GLOBAL TRAINING AND DEVELOPMENT
                            </h3>
                            <small>
                                (A KHDA licensee, an Approved CPD Provider and an ISO 9001-certified company based in Dubai, UAE)
                            </small>
                        </div>
                        <img
                            src={dataUrl}
                            // src={`https://qrcode.tec-it.com/API/QRCode?data=${BASEURL}certificate/${certificate._id}`}
                            alt="Logo"
                            style={{ height: "100px" }}
                        />
                    </div>

                    <hr style={{ margin: "20px 0" }} />

                    <h1 style={{ textAlign: "center", color: "#00007c", fontFamily: "Brush Script MT" }}>
                        Certificate of Course Completion
                    </h1>

                    <div className='text-center mt-5 mb-5'>
                        <p className="mt-0">
                            This certifies that <b style={{ color: "#cc0000" }}>{student.name}</b>
                        </p>
                        <p className="mt-3">
                            has completed <b style={{ color: "#cc0000" }}>{course.title}</b>
                        </p>
                        <p className="mt-3">
                            on <b style={{ color: "#00007c" }}>Acumen Glow</b>, the official e-learning platform of Acumen Global Training and Development
                        </p>
                        <p className="mt-3">
                            via an immersive learning experience through self-paced,
                        </p>
                        <p className="mt-3">
                            interactive modules incorporating videos, resource notes and performance assessment quizzes.
                        </p>
                    </div>

                    <div className="text-center">
                        {/* <div>
                            <b>Course duration:</b> [No. of hours]
                        </div> */}
                        <div>
                            <b>Completion Date:</b> {showdatetimein(certificate.certificate)}
                        </div>
                        <div className="mt-3">
                            <b>Certificate ID:</b> {certificate._id}
                        </div>
                        <div className="mt-3">
                            <b>Verify this certificate at:</b> <a href={`${BASEURL}certificate/${certificate._id}`}>{BASEURL}certificate/{certificate._id}</a>
                        </div>

                        <div className='mt-5' style={{ textAlign: "center", color: "#00007c", fontFamily: "Brush Script MT" }}>
                            This certificate has been issued electronically and is valid without a physical signature.
                        </div>

                    </div>
            </div>

            </div>
        </div>
        </>
    );
};


const thStyle = {
  border: "1px solid #ddd",
  padding: "8px",
  textAlign: "left",
};

const tdStyle = {
  border: "1px solid #ddd",
  padding: "8px",
};

export default StudentCertificate;
